<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-clock-edit-outline
        </v-icon> Edit Time Slot
      </h2>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container class="my-container-style">
          <v-col
            cols="12"
          >
            <v-autocomplete
              v-model="selectedTimeSlot"
              menu-props="auto"
              :items="timeSlots"
              item-value="id"
              item-text="name"
              :rules="[(v) => !!v || 'This field is required']"
              label="Time Slot*"
            />
          </v-col>

          <v-col
            cols="12"
          >
            <v-select
              v-model="organizationCategory"
              menu-props="auto"
              :items="organizationCategories"
              item-text="id"
              item-value="value"
              label="Organization Category*"
              prepend-icon="mdi-domain"
              :rules="[(v) => !!v || 'This field is required']"
              single-line
            />
          </v-col>
          <p class="text-sm-left">
            *Indicates required field
          </p>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="updateDigiBoardTimeSlot()"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'EditDigiBoardTimeSlot',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      digiboardtimeslotdetails: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        showModal: true,
        loading: false,
        isFormValid: false,
        selectedTimeSlot: '',
        organizationCategory: '',
        organizationCategories: [{ id: 'Host', value: 'host' }, { id: 'Advertiser', value: 'advertiser' }],
      };
    },
    computed: {
      timeSlots () {
        return this.$store.getters['digiboards/getTimeSlotsList'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      this.fillData();
      await this.getTimeSlotsList();
    },
    methods: {
      fillData () {
        this.selectedTimeSlot = this.digiboardtimeslotdetails.id;
        this.organizationCategory = this.digiboardtimeslotdetails.type;
      },
      async getTimeSlotsList () {
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchTimeSlotsList');
        this.loading = false;
      },
      async updateDigiBoardTimeSlot () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('digiboards/updateDigiBoardTimeSlot', {
          timeSlot: {
            time_slot_id: this.selectedTimeSlot,
            type: this.organizationCategory,
          },
          digiBoardTimeSlotId: this.digiboardtimeslotdetails.digi_board_time_slot_id,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Time slot updated successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('success');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        }); ;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-right: 5px;
}
.my-container-style {
    padding-top: 24px;
}
</style>
